import { service } from 'services';
import { hotGetAction, basicCRUDAction } from 'utils';
import { ACTIONS_TYPES } from '../helper';
import { getDispatch } from '../store';

const groupActions = {
  get: async ({ id }) => hotGetAction({
    action: ACTIONS_TYPES.GROUP.GET,
    apiResult: service.group.get({ id }),
    payloadKey: 'group',
  }),

  getAll: async () => hotGetAction({
    action: ACTIONS_TYPES.GROUP.GET_ALL,
    apiResult: service.group.getAll(),
    payloadKey: 'groups',
    isRetrieveItems: true,
  }),

  getUsers: async ({ groupId }) => hotGetAction({
    action: ACTIONS_TYPES.GROUP.GET_USERS,
    apiResult: service.group.getUsers({ groupId }),
    payloadKey: 'groupUsers',
    isRetrieveItems: true,
  }),

  create: async ({ group }) => basicCRUDAction({
    action: ACTIONS_TYPES.GROUP.CREATE,
    apiResult: service.group.create({ group }),
  }),

  update: async ({ id, group }) => basicCRUDAction({
    action: ACTIONS_TYPES.GROUP.UPDATE,
    apiResult: service.group.update({ id, group }),
  }),

  delete: async ({ id }) => basicCRUDAction({
    action: ACTIONS_TYPES.GROUP.DELETE,
    apiResult: service.group.delete({ id }),
  }),

  select: async ({ group }) => {
    const dispatch = getDispatch();

    return dispatch({
      type: ACTIONS_TYPES.COMMON.QUICK_UPDATE,
      payload: {
        selectedGroup: group,
      },
    });
  },

  addUser: async ({ groupId, userId }) => basicCRUDAction({
    action: ACTIONS_TYPES.GROUP.ADD_USER,
    apiResult: service.group.addUser({ groupId, userId }),
  }),

  deleteUser: async ({ groupId, userId }) => basicCRUDAction({
    action: ACTIONS_TYPES.GROUP.DELETE_USER,
    apiResult: service.group.deleteUser({ groupId, userId }),
  }),

  getResouces: async ({ groupId }) => hotGetAction({
    action: ACTIONS_TYPES.GROUP.GET_RESOURCES,
    apiResult: service.group.getResources({ groupId }),
    payloadKey: 'groupResources',
    isRetrieveItems: true,
  }),

  addResource: async ({ groupId, resourceId }) => basicCRUDAction({
    action: ACTIONS_TYPES.GROUP.ADD_RESOURCE,
    apiResult: service.group.addResource({ groupId, resourceId }),
  }),

  deleteResouce: async ({ groupId, resourceId }) => basicCRUDAction({
    action: ACTIONS_TYPES.GROUP.DELETE_RESOURCE,
    apiResult: service.group.deleteResource({ groupId, resourceId }),
  }),
};

export default groupActions;
